export const ELECTRICITY_PRODUCT = 'electricity'
export const GAS_PRODUCT = 'gas'

export const PRODUCT_TYPE_LABELS = {
  [ELECTRICITY_PRODUCT]: 'Electricidad',
  [GAS_PRODUCT]: 'Gas',
}
